import React, { useContext } from 'react';

interface TableContainerContextProps {
  shouldHeaderStick: boolean;
  isInteractive?: boolean;
}

export const TableContainerContext =
  React.createContext<TableContainerContextProps | null>(null);

export function useTableContainerContext(): TableContainerContextProps | null {
  const context = useContext(TableContainerContext);
  return context || null;
}
